export default {
  file: 'https://gateway.test.eastedu.ltd/file-service',
  api: 'https://openschool-api.test.eastedu.ltd/teaching_api',
  trackApi:
    'https://eastedu-test.cn-shenzhen.log.aliyuncs.com/logstores/open_school/track?APIVersion=0.6.0',
  userCenter: 'https://passport.eastedu.com/wechat/qrcode',
  // resourceCenter: 'http://192.168.101.59:58006',
  resourceCenterDownload: 'https://orgmember.test.eastedu.ltd',
  examinationAndAnalysis: 'http://192.168.101.59:55002',
  ebi: 'https://ebi.test.eastedu.ltd',
  ip: 'https://tool.eastedu.com/ip', // ip与服务器时间
  pingguoApi: 'https://gateway.test.eastedu.ltd/infrastructure-cache-service',
  userCenterApi: 'https://gateway.test.eastedu.ltd/user-center-api',
  markupService: 'https://gateway.test.eastedu.ltd/infrastructure-markup-service',
  SENTRY_DSN: 'https://df5e13a029044c6e80eba1f063b10207@sentry.test.eastedu.ltd/21',
  gateway: 'https://gateway.test.eastedu.ltd',
};
